import { createFileRoute, redirect } from '@tanstack/react-router';

// AB#654: API keys are per-user, not per-site — the card moved to /account/api-keys.
// Kept as a redirect so the site-settings sub-nav item and old links still land.
export const Route = createFileRoute('/sites/$siteSlug/settings/api-keys')({
  beforeLoad: () => {
    throw redirect({ to: '/account/api-keys' });
  },
});
